import React, { useState, useEffect } from "react";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  OutlinedInput,
  Box,
  Popover,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  AirplaneTicket,
  Close,
  Delete,
  RemoveRedEyeOutlined,
  ViewAgenda,
} from "@mui/icons-material";

export default function TicketViewersList({
  isloading,
  isListOpen,
  setIsListOpen,
  ticketViewersList,
  employeesList,
  selectedValues,
  setSelectedValues,
  onSubmit,
  deleteId,
  setDeleteId,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDeleteItem = (id) => {
    setDeleteId(id);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popup-list" : undefined;

  const handleAddTicketViewer = () => {
    setIsListOpen("TICKET_VIEWERS");
  };

  return (
    <div>
      <IconButton
      className="ViewerButton"
        aria-label="open drawer"
        onClick={handleOpen}
        sx={{
          color: "#08459c", // Customize the color

          "&:hover": {
            backgroundColor: "gray", // Customize the background color on hover
          },
          "& .MuiSvgIcon-root": {
            marginRight: "8px", // Adjust the spacing between the icon and the text
          },
        }}
      >
        <Typography
          variant="body2" // Set the desired variant for the text size
          sx={{
            fontSize: "12px", // Customize the font size
          }}
          
        >
          <RemoveRedEyeOutlined />
          Ticket Viewers
        </Typography>
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          maxHeight: "400px", // Set the maximum height as per your requirements
        }}
      >
        <div style={{ position: "relative", zIndex: 9999 }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              m: 1,
              zIndex: 9999,
            }}
          >
            <Close />
          </IconButton>
        </div>
        <br />
        <Typography sx={{ p: 2 }}>
          <List>
            {ticketViewersList.map((item, index) => (
              <ListItem
                key={item.id}
                sx={{ zIndex: 1 }} // Set a higher zIndex value to keep the list items above the button
              >
                <ListItemText primary={item.firstname + " " + item.lastname} />
                {item.id === deleteId ? (
                  <CircularProgress sx={{ m: 1 }}></CircularProgress>
                ) : (
                  <IconButton
                    color="error"
                    onClick={() => handleDeleteItem(item.id)}
                  >
                    <Delete />
                  </IconButton>
                )}
              </ListItem>
            ))}
          </List>
          <Button
            sx={{ position: "sticky", bottom: 0, zIndex: 2 }} // Set a higher zIndex value to keep the button above the list items
            onClick={handleAddTicketViewer}
            className="blue-button"
          >
            Add Ticket Viewers
          </Button>
        </Typography>
      </Popover>
    </div>
  );
}
